package songwritersnotebook.app.utils

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DatamuseWord(
    @SerialName("word") val word: String,
    @SerialName("score") val score: Int? = null
)

private const val BASE_URL = "https://api.datamuse.com/words"

class ThesaurusService(private val client: HttpClient) {
    suspend fun getSynonyms(word: String): List<String>? {
        if (word.isBlank()) {
            return emptyList()
        }
        return withContext(Dispatchers.Default) {
            try {
                val response: List<DatamuseWord> = client.get(BASE_URL) {
                    parameter("rel_syn", word)
                }.body()
                response.map { it.word }
            } catch (e: Exception) {
                println("ThesaurusService: Error fetching synonyms: ${e.message}")
                null
            }
        }
    }
}
